import React from 'react';

import { MenuItem, TextField, TextFieldProps, InputBaseProps } from '@mui/material';

import { Option } from '../../../../general-types';

export type SelectProps<TOption extends Option> = {
  value: TOption['value'];
  onChange: (value: TOption['value']) => void;
  options: TOption[];
  dataTestId?: string;
  InputProps?: InputBaseProps;
  displayEmpty?: true; // can't be false because fixed label in shrink mode
} & Omit<TextFieldProps, 'select' | 'value' | 'onChange'>;

/**
 * uncontrolled by react-hook-form select component
 */
const Select = <TOption extends Option>({
  value,
  onChange,
  options,
  dataTestId,
  InputProps,
  displayEmpty,
  ...props
}: SelectProps<TOption>) => {
  return (
    <TextField
      select
      value={value}
      onChange={(event) => onChange(event.target.value)}
      fullWidth
      data-test-id={dataTestId}
      slotProps={{
        input: InputProps,
        select: {
          displayEmpty,
        },
        inputLabel: {
          shrink: displayEmpty,
        },
      }}
      {...props}
    >
      {options.map((option) => (
        <MenuItem value={option.value} key={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export { Select };
